import { useMemo } from 'react';

import { ErrorOutlined, ReportProblemOutlined } from '@mui/icons-material';
import { ActionItemKeys } from '@uplift/api';
import { paymentsTabRoute } from '@uplift/constants';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';

export const useBillingActionItem = () => {
  const l10n = useL10n();
  const clientCard = useActionItem(ActionItemKeys.CLIENT_BILLING);

  const billingActionItem = useMemo(() => {
    if (clientCard.isLoading) {
      return null;
    }

    if (!clientCard?.show) {
      return null;
    }

    if (clientCard?.expired) {
      return (
        <LinkDashboardActionItem
          title={l10n.dashboard.actionItems.cardExpired.title}
          details={l10n.dashboard.actionItems.cardExpired.subtitle}
          color="danger"
          icon={<ErrorOutlined />}
          actionText="Update Card"
          link={paymentsTabRoute.createLink({ tab: 'method' })}
          onClick={() =>
            trackToDoCTA({
              toDoType: ActionItemKeys.CLIENT_BILLING,
              userType: UserRole.patient
            })
          }
        />
      );
    }

    if (clientCard?.expirationDays <= 30) {
      const expirationDate = CalendarDateService.date(new Date(clientCard.expYear, clientCard.expMonth));

      return (
        <LinkDashboardActionItem
          title={l10n.dashboard.actionItems.cardExpiration.title}
          details={l10n.dashboard.actionItems.cardExpiration.subtitle(expirationDate.format('MMM'))}
          color="warning"
          icon={< ReportProblemOutlined />}
          actionText="Update Card"
          link={paymentsTabRoute.createLink({ tab: 'method' })}
          onClick={() =>
            trackToDoCTA({
              toDoType: ActionItemKeys.CLIENT_BILLING,
              userType: UserRole.patient
            })
          }
        />
      );
    }
  }, [ l10n, clientCard ]);

  return {
    isLoading: clientCard.isLoading,
    actionItem: billingActionItem
  };
};
